import { AccessTimeOutlined, AddPhotoAlternateOutlined, ArrowForward, BusinessOutlined, CalendarTodayOutlined, ConfirmationNumberOutlined, EditOutlined, FlightTakeoffOutlined, InfoOutlined, Inventory2Outlined, Launch, Link as LinkIcon, LocalPhoneOutlined, MailOutline, PersonOutline, ScaleOutlined } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import RouteIcon from '@mui/icons-material/Route';
import SaveIcon from '@mui/icons-material/Save';
import { Alert, Backdrop, Box, Breadcrumbs, Button, Card, CardContent, CardMedia, CircularProgress, Divider, Grid, IconButton, Link, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, MenuProps, Paper, TextField } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Fab from '@mui/material/Fab/Fab';
import Typography from '@mui/material/Typography';
import Zoom from '@mui/material/Zoom/Zoom';
import { AssosiateFlightAndOrder, createDefault, Display, FlightInfo, getDestinationContactFromOrderInfo, getRequesterContactFromOrderInfo, getSizeLabel, getVolumeLabel, getWeightLabel, isBusinessDestinationInfo, isBusinessRequesterInfo, isMaritimeOrderInfo, OrderInfo, OrderStatus, PackageImage, ReceiveStatus, sumTotalWeight, TakeImagePhase, UserInfo } from 'adoms-common-lib';
import axios from 'axios';
import { QRCodeCanvas } from 'qrcode.react';
import queryString from "query-string";
import React, { useEffect, useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { makeStyles, withStyles } from 'tss-react/mui';
import { useUserInfoContext } from '../../../common/UserContext';
import ReceiveStatusInfo from '../../../components/atoms/ReceiveStatusInfo';
import { OrderImageDialog } from '../../../components/molecule/OrderImageDialog';
import { FlightCreateDialog } from '../../../components/organisms/FlightCreateDialog';
import OperationMenuBar from '../../../components/organisms/OperationMenuBar';
import { OrderTieFlightDialog } from '../../../components/organisms/OrderTieFlightDialog';
import { APIConnector } from '../../../connector/APIConnector';

const drawerWidth = 260;

const useStyles = makeStyles()((theme: any) => ({
  griditem: {
  },

  root: {
    display: 'flex',
    backgroundColor: theme.palette.background.default
  },

  title: {
    flexGrow: 1,
    textAlign: 'center',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
  },

  table: {
    minWidth: 100,
  },

  formControl: {
    margin: theme.spacing(1),
    minWidth: 100,
  },

  /**
   * メニューヘッダー
   */
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'flex-end',
  },

  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },

  /**
   * 
   */
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },


  paper: {
    padding: '12px',
    textAlign: 'center',
    height: '100%',
  },
  errorMessage: {
    marginTop: theme.spacing(2),
    padding: '12px',
    textAlign: 'center',
    height: '100%',
  },
  orderInfoNoticePaper: {
    padding: '12px 0px 12px 0px',
    textAlign: 'center',
    height: '100%',
  },

  savefab: {
    position: 'fixed',
    marginTop: theme.spacing(-1),
    right: theme.spacing(3),
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  cancelfab: {
    position: 'fixed',
    marginTop: theme.spacing(-1),
    right: theme.spacing(24),
  }
}));



const StyledMenu = withStyles((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
), {
  paper: {
    border: '1px solid #d3d4d5',
  },
});

const StyledMenuItem = withStyles(MenuItem, (theme: any) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.primary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}));



/**
 * ステータスが到着以降であるかを確認する
 * @param order 
 */
function isArrivedOrLater(order: OrderInfo): boolean {
  if (order.status === OrderStatus.Arrivaled ||
    order.status === OrderStatus.ReturnInPreparation ||
    order.status === OrderStatus.ReturnInFlight ||
    order.status === OrderStatus.ReturnArrivingSoon ||
    order.status === OrderStatus.ReturnArrivaled ||
    order.status === OrderStatus.Completed) {
    return true;
  }
  return false;
}


/**
 * 詳細
 */
export default function OrderDetailView(props: any) {
  const { classes, cx } = useStyles();
  const navigate = useNavigate();
  const userInfoContext = useUserInfoContext();

  type OrderViewState =
    | { kind: 'loading' }
    | { kind: 'loaded'; order: OrderInfo }
    | { kind: 'error'; message: string };

  const location = useLocation();
  const [isOpen, setOpen] = React.useState(false);
  const qs = queryString.parse(location.search);
  const [orderID, setorderID] = React.useState<{ orderID: string }>(location.state == undefined ? { orderID: qs.orderID as string } : location.state as { orderID: string })
  const [orderState, setOrderState] = React.useState<OrderViewState>({ kind: 'loading' });
  const [orderReceiptImageBase64, setOrderReceiptImageBase64] = React.useState<string>('');
  const [assosiateFlightAndOrder, setAssosiateFlightAndOrder] = React.useState<AssosiateFlightAndOrder | undefined>(undefined);
  const [flight, setFlight] = React.useState(createDefault());

  const [receiveMenu, setReceiveMenu] = React.useState<null | HTMLElement>(null);
  const [isImageOnLoad, setIsImageOnload] = React.useState(false);

  //ステータスが変更された場合true
  const [isEdit, setEdit] = React.useState(false);

  const [isNewFlightDialogOpen, setNewFlightDialogOpen] = React.useState(false);
  const [isOrderTieFlightDialogOpen, setOrderTieFlightDialogOpen] = React.useState(false);

  const [isDisplayLoadingMarkForUserInfo, setDisplayLoadingMarkForUserInfo] = React.useState(false);
  const [userInfo, setUserInfo] = React.useState<UserInfo | undefined>(userInfoContext.userInfo);
  const [isOrderImageDialogOpen, setOrderImageDialogOpen] = React.useState(false);

  const TAKE_IMAGE_PHASE_ITEMS: { phase: TakeImagePhase, label: string }[] = [
    { phase: TakeImagePhase.Received, label: '受領時' },
    { phase: TakeImagePhase.Packed, label: '梱包時' },
    { phase: TakeImagePhase.Loaded, label: '搭載時' },
  ];

  const createEmptyPhaseImageState = (): Record<TakeImagePhase, PackageImage[]> => ({
    [TakeImagePhase.Received]: [],
    [TakeImagePhase.Packed]: [],
    [TakeImagePhase.Loaded]: []
  });

  const [maritimePhaseImageState, setMaritimePhaseImageState] = React.useState<Record<TakeImagePhase, PackageImage[]>>(createEmptyPhaseImageState());
  const [isPrefetchingMaritimeImages, setIsPrefetchingMaritimeImages] = React.useState<boolean>(false);
  const [maritimeImageErrorMessage, setMaritimeImageErrorMessage] = React.useState<string | undefined>(undefined);
  const [maritimeImageRefreshNonce, setMaritimeImageRefreshNonce] = React.useState<number>(0);
  const maritimePrefetchRequestIdRef = React.useRef<number>(0);

  // 同じタイミングでエラーが発生する可能性があるため、上書きされないようにエラーメッセージ表示場所を分ける
  const [errorMessage, setErrorMessage] = React.useState<string | undefined>(undefined)
  const [userErrorMessage, setUserErrorMessage] = React.useState<string | undefined>(undefined)

  const [orderForReset, setOrderForReset] = React.useState<OrderInfo | undefined>(undefined);
  const [assosiateFlightAndOrderForReset, setassosiateFlightAndOrderForReset] = React.useState<AssosiateFlightAndOrder | undefined>(undefined);
  const [flightForReset, setFlightForReset] = React.useState<FlightInfo | undefined>(createDefault());

  const loadedOrder = orderState.kind === 'loaded' ? orderState.order : undefined;

  //配送依頼情報を取得
  useLayoutEffect(() => {
    const fetchData = async () => {
      let c: APIConnector = APIConnector.instance;
      setOrderState({ kind: 'loading' });
      //メモ：Lambdaコンテナ初回起動時、画像サイズによって読込が5秒くらいかかる
      let getOrderPromise = c.getOrderForOperation(orderID.orderID).then(orderInfo => {
        if (typeof orderInfo.receiptFileName !== 'undefined') {
          c.getReciept(orderID.orderID, orderInfo.receiptFileName!).then(response => {
            setIsImageOnload(true);
            setOrderReceiptImageBase64(response);
            setErrorMessage(undefined);
          }).catch(error => {
            setIsImageOnload(true);
            setErrorMessage("データを正常に読み込めませんでした。ページを再読み込みして操作をやりなおしてください。");
            console.log(error);
          });
        } else {
          setIsImageOnload(true);
        }
        return orderInfo;
      });
      let assosiateFlightAndOrderPromise = c.getFlightIdTiedToOrderId(orderID.orderID)
      let getFlightPromise = assosiateFlightAndOrderPromise.then(data => {
        if (data.length === 0) {
          return Promise.resolve(createDefault());
        }
        /*
        フライトとオーダーは多対多になる予定だが、
        現状オーダーに紐づけられるフライトは1個であるため、
        このようなコードとしている
        */
        return c.getFlight(data[0].flightId);
      });
      await Promise.all([getOrderPromise, assosiateFlightAndOrderPromise, getFlightPromise]).then(value => {
        let currentOrder = value[0];
        setOrderState({ kind: 'loaded', order: currentOrder });

        const copyOrder = JSON.parse(JSON.stringify(currentOrder)) as OrderInfo;
        setOrderForReset(copyOrder);

        let currentAssosiateFlightAndOrder = value[1];
        setAssosiateFlightAndOrder(currentAssosiateFlightAndOrder[0]);
        if (typeof currentAssosiateFlightAndOrder[0] !== "undefined") {
          const copyAssosiateFlightAndOrder = JSON.parse(JSON.stringify(currentAssosiateFlightAndOrder[0])) as AssosiateFlightAndOrder;
          setassosiateFlightAndOrderForReset(copyAssosiateFlightAndOrder);
        }

        let currentFlight = value[2];
        setFlight(currentFlight);
        if (typeof currentAssosiateFlightAndOrder !== "undefined") {
          const copyFlight = JSON.parse(JSON.stringify(currentFlight)) as FlightInfo;
          setFlightForReset(copyFlight);
        }
        setErrorMessage(undefined);
      }).catch(error => {
        console.log("error: " + error);

        if (axios.isAxiosError(error)
          && typeof error.response !== "undefined"
          && error.response.status === 403) {
          handleToForbidden403Page();
        } else {
          setIsImageOnload(true);
          const msg = "データを正常に読み込めませんでした。ページを再読み込みして操作をやりなおしてください。";
          setErrorMessage(msg);
          setOrderState({ kind: 'error', message: msg });
        }
      });
    }
    fetchData();
  }, []);

  /**
  * userInfoを取得する
  */
  useEffect(() => {
    if (userInfoContext.isError) {
      setUserErrorMessage("ユーザー情報が取得できませんでした。一部の機能が使えないことがあります。");
      setDisplayLoadingMarkForUserInfo(false);
    } else {
      setUserErrorMessage(undefined);
      if (typeof userInfoContext.userInfo === "undefined") {
        setDisplayLoadingMarkForUserInfo(true);
      } else {
        setDisplayLoadingMarkForUserInfo(false);
      }
    }
    setUserInfo(userInfoContext.userInfo);
  }, [userInfoContext]);

  useEffect(() => {
    if (!loadedOrder || !isMaritimeOrderInfo(loadedOrder)) {
      setMaritimePhaseImageState(createEmptyPhaseImageState());
      setIsPrefetchingMaritimeImages(false);
      setMaritimeImageErrorMessage(undefined);
      return;
    }

    const requestId = maritimePrefetchRequestIdRef.current + 1;
    maritimePrefetchRequestIdRef.current = requestId;

    const fetchMaritimePackageImages = async () => {
      try {
        setIsPrefetchingMaritimeImages(true);
        setMaritimeImageErrorMessage(undefined);

        const apiConnector: APIConnector = APIConnector.instance;
        const results = await Promise.all(
          TAKE_IMAGE_PHASE_ITEMS.map(async ({ phase }) => {
            const images = await apiConnector.getPackageImage(loadedOrder.orderID, phase);
            return { phase, images };
          })
        );

        if (maritimePrefetchRequestIdRef.current !== requestId) {
          return;
        }

        const phaseImageState = createEmptyPhaseImageState();
        results.forEach(({ phase, images }) => {
          phaseImageState[phase] = images;
        });
        setMaritimePhaseImageState(phaseImageState);
      } catch (error) {
        console.log(error);

        if (maritimePrefetchRequestIdRef.current !== requestId) {
          return;
        }

        setMaritimeImageErrorMessage('注文内容が取得できませんでした。');
        setMaritimePhaseImageState(createEmptyPhaseImageState());
      } finally {
        if (maritimePrefetchRequestIdRef.current !== requestId) {
          return;
        }
        setIsPrefetchingMaritimeImages(false);
      }
    };

    fetchMaritimePackageImages();
  }, [loadedOrder, maritimeImageRefreshNonce]);

  /**
   * メニューバーが開かれたときのハンドラ
   */
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  /**
   * メニューバーが閉じられた時のハンドラ
   */
  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleReceiveStatusClick = (event: React.MouseEvent<HTMLElement>) => {
    setReceiveMenu(event.currentTarget);
  };

  const handleReceiveStatusClose = () => {
    setReceiveMenu(null);
  };

  /**
   * 配送状況を変更するときのハンドラ
   * @param event 
   * @param newStatus 
   */
  const handleReceiveStatusChange = (event: React.MouseEvent<HTMLElement>, newStatus: ReceiveStatus) => {
    console.log(newStatus + ":" + event);
    setReceiveMenu(null);
    if (!loadedOrder) {
      return;
    }
    if (loadedOrder.receiveStatus !== newStatus) {
      setOrderState({ kind: 'loaded', order: { ...loadedOrder, receiveStatus: newStatus } as OrderInfo });
      setEdit(true);
    }
  }


  /**
   * セーブするときのハンドラ
   */
  const handleSaveClick = () => {
    if (!loadedOrder) {
      return;
    }
    setEdit(false);
    setDisplayLoadingMarkForUserInfo(true);
    const fetchData = async () => {
      /**
       * dynamoDBにorderを保存
       */
      let apigw: APIConnector = APIConnector.instance;
      let result: Promise<void | OrderInfo> = apigw.putOrderChange(loadedOrder);
      result.then((value: void | OrderInfo) => {
        /**
         * 戻りの配送依頼情報を初期値にセットする
         */
        let saveOrder = value as OrderInfo;
        setOrderState({ kind: 'loaded', order: saveOrder });
        setErrorMessage(undefined);
        setDisplayLoadingMarkForUserInfo(false);
      }).catch((error) => {
        console.log("エラー:" + error);
        if (axios.isAxiosError(error)
          && typeof error.response !== "undefined"
          && error.response.status === 403) {
          setErrorMessage("権限がありません。");
        } else {
          setErrorMessage("保存できませんでした。ページを再読み込みして操作をやりなおしてください。");
        }
        setEdit(true);
        setDisplayLoadingMarkForUserInfo(false);
      });
    }
    fetchData();

  }

  /**
   * 次のページに遷移する際の処理
   * @param event 
   * @param navigate 
   */
  const handleGotoFlight = (event: any, order: OrderInfo) => {
    navigate(
      "/flightoperationview",
      {
        state: { id: assosiateFlightAndOrder?.flightId ?? "" },
      })
  }

  /**
 * ダイアログを開く
 * @param scrollType 
 */
  const handleClickNewFlightDialogOpen = () => {
    setNewFlightDialogOpen(true);
  };

  /**
   * 既存フライト紐付けダイアログを開く
   */
  const handleClickOrderTieFlightDialogOpen = () => {
    setOrderTieFlightDialogOpen(true);
  };

  /**
   * ダイアログをクローズする
   */
  const handleNewFlightDialogClose = () => {
    setNewFlightDialogOpen(false);
  };

  /**
   * 403ページに遷移させる
   * @param navigate 
   */
  const handleToForbidden403Page = () => {
    navigate(
      "/forbidden403Page"
    )
  }

  /**
   * 元に戻すときのハンドラ
   */
  const handleCancelClick = async () => {
    setEdit(false);

    if (!orderForReset) {
      return;
    }

    let copyOrder = JSON.parse(JSON.stringify(orderForReset)) as OrderInfo;
    setOrderState({ kind: 'loaded', order: copyOrder });

    if (typeof assosiateFlightAndOrderForReset !== "undefined") {
      let copyAssosiateFlightAndOrder = JSON.parse(JSON.stringify(assosiateFlightAndOrderForReset)) as AssosiateFlightAndOrder ?? undefined;
      setAssosiateFlightAndOrder(copyAssosiateFlightAndOrder);
    }

    if (typeof flightForReset !== "undefined") {
      let copyFlight = JSON.parse(JSON.stringify(flightForReset)) as FlightInfo;
      setFlight(copyFlight);
    }
  }

  const renderPartyInfo = (
    title: string,
    contact: {
      lastname: string;
      firstname: string;
      tel?: string | null;
      mailaddress?: string | null;
    },
    companyName?: string
  ) => (
    <React.Fragment>
      <Grid container alignItems="center" wrap="nowrap" sx={{ mb: 1 }}>
        <Grid item sx={{ display: 'flex', alignItems: 'center', mr: 1.5 }}>
          <PersonOutline sx={{ color: 'text.secondary' }} />
        </Grid>
        <Grid item>
          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
            {title}
          </Typography>
        </Grid>
      </Grid>
      <Grid container direction="column" sx={{ pl: 4.5 }}>
        {renderPartyInfoItems(contact, companyName)}
      </Grid>
    </React.Fragment>
  );

  const renderPartyInfoItems = (
    contact: {
      lastname: string;
      firstname: string;
      tel?: string | null;
      mailaddress?: string | null;
    },
    companyName?: string
  ) => (
    <React.Fragment>
      {companyName ? (
        <Grid item>
          <Typography color="text.primary" sx={{ mb: 0.5, fontWeight: 'medium' }}>{companyName}</Typography>
        </Grid>
      ) : null}
      <Grid item>
        <Typography color="text.primary" sx={{ mb: 0.5, fontWeight: 'medium' }}>{`${contact.lastname} ${contact.firstname}`}</Typography>
      </Grid>
      {(contact.tel ?? "") !== "" ? (
        <Grid item>
          <Grid container alignItems="center" wrap="nowrap" spacing={1}>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <LocalPhoneOutlined fontSize="small" sx={{ color: 'text.secondary', display: 'block' }} />
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                {contact.tel}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ) : null}
      {(contact.mailaddress ?? "") !== "" ? (
        <Grid item>
          <Grid container alignItems="center" wrap="nowrap" spacing={1}>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <MailOutline fontSize="small" sx={{ color: 'text.secondary', display: 'block' }} />
            </Grid>
            <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.2 }}>
                {contact.mailaddress}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </React.Fragment>
  );

  // 総重量取得（goods[0] に格納）
  const getTotalWeight = (): string => {
    if (!loadedOrder || loadedOrder.goods.length === 0) return '';

    // 海自の場合: goods 全件の weight を合算して表示
    if (isMaritimeOrderInfo(loadedOrder)) {
      const total = sumTotalWeight(loadedOrder.goods);
      return String(total);
    }

    // それ以外: 既存仕様 (goods[0] に格納)
    // @ts-ignore 既存GoodsInfoにweightプロパティがある前提
    const weight = loadedOrder.goods[0]?.weight;
    return (weight == null) ? '' : String(weight);
  };

  // 総重量変更ハンドラ
  const handleTotalWeightChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // MaritimeOrderInfo の重量は goods 全件から算出して表示しているため、この画面での編集は不可
    if (!loadedOrder || isMaritimeOrderInfo(loadedOrder)) return;

    const changeValue = e.target.value;
    let orderLocal = structuredClone(loadedOrder);
    const num = changeValue === '' ? 0 : Number(changeValue);
    if (Number.isNaN(num) || (num as number) < 0) return;
    if (orderLocal.goods.length === 0) {
      return; // 配送物が未設定の場合は何もしない
    } else {
      // @ts-ignore
      orderLocal.goods[0].weight = num;
    }

    setOrderState({ kind: 'loaded', order: orderLocal });
    setEdit(true);
  };

  const requesterContact = loadedOrder ? getRequesterContactFromOrderInfo(loadedOrder) : undefined;
  const destinationContact = loadedOrder ? getDestinationContactFromOrderInfo(loadedOrder) : undefined;

  return (
    <div className={classes.root}>
      <CssBaseline />

      {/**メニューバーを表示する */}
      <OperationMenuBar
        onChangeDrawerOpen={handleDrawerOpen}
        onChangeDrawerClose={handleDrawerClose}
        open={isOpen}
        title="配送管理"
        bgcolor="#00695f"
      />

      {/** コンテンツ部分 */}
      <main
        className={cx(classes.content, {
          /** メニューバーがオープン・クローズされたときのスタイルの変更*/
          [classes.contentShift]: isOpen,
        })}
      >
        <div className={classes.drawerHeader} />
        {
          /**
           * データが更新されている場合、保存ボタンを表示する
           */
          isEdit ?
            (
              <React.Fragment>
                <Zoom in={isEdit} style={{ transitionDelay: isEdit ? '500ms' : '0ms' }}>
                  <Button variant="contained" color="primary"
                    size="large"
                    className={classes.cancelfab}
                    startIcon={<ClearOutlinedIcon />}
                    onClick={handleCancelClick}
                    disabled={!isEdit}
                    style={{ zIndex: 1000 }}
                  >
                    元に戻す
                  </Button>
                </Zoom>
                <Zoom in={isEdit} style={{ transitionDelay: isEdit ? '500ms' : '0ms' }}>
                  <Button variant="contained" color="secondary"
                    size="large"
                    className={classes.savefab}
                    startIcon={<SaveIcon />}
                    onClick={handleSaveClick}
                    disabled={!isEdit}
                    style={{ zIndex: 3000 }}
                  >
                    変更を保存
                  </Button>
                </Zoom>
              </React.Fragment>
            ) : null
        }

        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit" href="/orderlistview" variant="h5">
            配送依頼一覧
          </Link>
          <Typography color="textPrimary" aria-current="page" variant="h5">
            配送依頼詳細
          </Typography>
        </Breadcrumbs>


        <Grid item xs={12} sm={12} className={classes.griditem}>
          {
            errorMessage ? (
              <Paper className={classes.errorMessage} elevation={1}>
                <Alert severity="error">{errorMessage}</Alert>
              </Paper>
            ) : (null)
          }
          {
            userErrorMessage ? (
              <Paper className={classes.errorMessage} elevation={1}>
                <Alert severity="error">{userErrorMessage}</Alert>
              </Paper>
            ) : (null)
          }
        </Grid>
        <br />

        {loadedOrder && requesterContact && destinationContact ? (
          <React.Fragment>
            {/* 配送サマリー */}
            <Grid container spacing={3} sx={{ mb: 3 }} alignItems="stretch">
              <Grid item xs={12} sm={6} sx={{ display: 'flex' }}>
                <Paper
                  elevation={3}
                  sx={{ p: 3, mb: 3, borderRadius: '12px', flexGrow: 1, display: 'flex', flexDirection: 'column' }}
                >
                  <Grid container direction="column" spacing={2} sx={{ flexGrow: 1 }}>
                    <Grid item sx={{ display: 'flex' }}>
                      <ReceiveStatusInfo status={loadedOrder.receiveStatus} />
                      <Zoom in={true} style={{ transitionDelay: '500ms' }}>
                        <IconButton size="small" onClick={handleReceiveStatusClick}><EditOutlined /></IconButton>
                      </Zoom>
                      <StyledMenu
                        id="customized-menu"
                        anchorEl={receiveMenu}
                        keepMounted
                        open={Boolean(receiveMenu)}
                        onClose={handleReceiveStatusClose}
                      >
                        <StyledMenuItem selected={loadedOrder.receiveStatus === ReceiveStatus.WaitingForPickup} onClick={(e: any) => { handleReceiveStatusChange(e, ReceiveStatus.WaitingForPickup) }}>
                          <ListItemIcon>
                            <ReceiveStatusInfo status={ReceiveStatus.WaitingForPickup} />
                          </ListItemIcon>
                        </StyledMenuItem>
                        <StyledMenuItem selected={loadedOrder.receiveStatus === ReceiveStatus.DepartForPort} onClick={(e: any) => { handleReceiveStatusChange(e, ReceiveStatus.DepartForPort) }}>
                          <ListItemIcon>
                            <ReceiveStatusInfo status={ReceiveStatus.DepartForPort} />
                          </ListItemIcon>
                        </StyledMenuItem>
                        <StyledMenuItem selected={loadedOrder.receiveStatus === ReceiveStatus.Preparation} onClick={(e: any) => { handleReceiveStatusChange(e, ReceiveStatus.Preparation) }}>
                          <ListItemIcon>
                            <ReceiveStatusInfo status={ReceiveStatus.Preparation} />
                          </ListItemIcon>
                        </StyledMenuItem>
                        <StyledMenuItem selected={loadedOrder.receiveStatus === ReceiveStatus.Loaded} onClick={(e: any) => { handleReceiveStatusChange(e, ReceiveStatus.Loaded) }}>
                          <ListItemIcon>
                            <ReceiveStatusInfo status={ReceiveStatus.Loaded} />
                          </ListItemIcon>
                        </StyledMenuItem>
                        <StyledMenuItem selected={loadedOrder.receiveStatus === ReceiveStatus.Received} onClick={(e: any) => { handleReceiveStatusChange(e, ReceiveStatus.Received) }}>
                          <ListItemIcon>
                            <ReceiveStatusInfo status={ReceiveStatus.Received} />
                          </ListItemIcon>
                        </StyledMenuItem>
                        <StyledMenuItem selected={loadedOrder.receiveStatus === ReceiveStatus.Cancel} onClick={(e: any) => { handleReceiveStatusChange(e, ReceiveStatus.Cancel) }}>
                          <ListItemIcon>
                            <ReceiveStatusInfo status={ReceiveStatus.Cancel} />
                          </ListItemIcon>
                        </StyledMenuItem>
                      </StyledMenu>
                    </Grid>
                    <Grid item>
                      <Grid container direction="column">
                        <Typography variant="body2" color="text.secondary" sx={{ marginTop: 1 }}>
                          確認番号: {loadedOrder.orderID}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', my: 1 }}>
                          <Typography fontSize="medium" sx={{ fontWeight: 'bold' }}>{loadedOrder.departure.name}</Typography>
                          <ArrowForward sx={{ mx: 2 }} />
                          <Typography fontSize="medium" sx={{ fontWeight: 'bold' }}>{loadedOrder.arrival.name}</Typography>
                        </Box>
                      </Grid>
                    </Grid>
                  </Grid>
                </Paper>
              </Grid>
              <Grid item xs={12} md={2} sx={{ display: 'flex' }}>
                <Paper
                  elevation={3}
                  sx={{ p: 3, mb: 3, borderRadius: '12px', flexGrow: 1, display: 'flex', flexDirection: 'column' }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                    <AccessTimeOutlined sx={{ mr: 1.5, color: 'text.secondary' }} />
                    <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                      受付時間
                    </Typography>
                  </Box>
                  <Divider />
                  <Typography variant="h5" sx={{ textAlign: 'center', fontWeight: 'medium', m: 'auto' }}>
                    {loadedOrder.orderID !== '' ? Display.getDateTimeStringFromISO8601(loadedOrder.orderDate) : ""}
                  </Typography>
                </Paper>
              </Grid>
            </Grid>

            <Grid container spacing={3} justifyContent={"center"} alignItems={"flex-start"}>
              {/* 左カラム */}
              <Grid item xs={12} md={6}>
                {/* 配送情報 */}
                <Card sx={{ borderRadius: '12px', height: '100%' }}>
                  <CardContent sx={{ paddingBottom: '0px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      {
                        //TODO: アイコン
                      }
                      <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                        配送情報
                      </Typography>
                    </Box>
                    <Divider sx={{ mb: 2 }} />
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={6}>
                        <List dense>
                          <ListItem>
                            <ListItemIcon><CalendarTodayOutlined fontSize="small" /></ListItemIcon>
                            <ListItemText primary="フライト希望日時" secondary={`${loadedOrder.preferredDeliveryDate} ${loadedOrder.preferredDeliveryTime}`} />
                          </ListItem>
                          <ListItem>
                            <ListItemIcon><BusinessOutlined fontSize="small" /></ListItemIcon>
                            <ListItemText primary="パートナーID" secondary={loadedOrder.businessPartnerId} />
                          </ListItem>
                          {isMaritimeOrderInfo(loadedOrder) ? (
                            <React.Fragment>
                              <ListItem>
                                <ListItemIcon><RouteIcon fontSize="small" /></ListItemIcon>
                                <ListItemText primary="配送ルート" secondary={loadedOrder.transportRoute || "なし"} />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon><ConfirmationNumberOutlined fontSize="small" /></ListItemIcon>
                                <ListItemText primary="補給本部伝票番号" secondary={loadedOrder.supplyHqVoucherNumber ? loadedOrder.supplyHqVoucherNumber : "なし"} />
                              </ListItem>
                              <ListItem>
                                <ListItemIcon><ConfirmationNumberOutlined fontSize="small" /></ListItemIcon>
                                <ListItemText primary="日通運送状番号" secondary={loadedOrder.carrierWaybillNumber ? loadedOrder.carrierWaybillNumber : "なし"} />
                              </ListItem>
                            </React.Fragment>
                          ) : null}
                          <ListItem>
                            <ListItemIcon><Link fontSize="small" /></ListItemIcon>
                            <ListItemText primary="外部連携" secondary={loadedOrder.externalOrderID != null ? loadedOrder.externalOrderID : "なし"} />
                          </ListItem>
                        </List>
                      </Grid>
                      <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <QRCodeCanvas value={loadedOrder.orderID} />
                      </Grid>
                    </Grid>
                    <Divider sx={{ marginTop: 2 }} />
                    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mt: 2 }}>
                      <FlightTakeoffOutlined sx={{ mr: 1.5, color: 'text.secondary' }} />
                      {flight.id === "" ? (
                        <Box
                          sx={{
                            display: 'flex',
                            flexGrow: 1,
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 2
                          }}
                        >
                          {
                            //TODO: ボタン文言化
                          }
                          <Alert severity="warning" sx={{ flexGrow: 1 }}>フライト未設定</Alert>
                          <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                            <Fab
                              color="primary"
                              aria-label="Tie"
                              size="small"
                              onClick={handleClickOrderTieFlightDialogOpen}
                            >
                              <LinkIcon />
                            </Fab>
                            <Fab
                              color="primary"
                              aria-label="Add"
                              size="small"
                              onClick={handleClickNewFlightDialogOpen}
                            >
                              <AddIcon />
                            </Fab>
                          </Box>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                            フライトID:
                          </Typography>
                          <Link href="#" underline="hover" sx={{ ml: 2, fontWeight: 'bold', display: 'flex', alignItems: 'center' }} onClick={(event) => handleGotoFlight(event, loadedOrder)}>
                            {flight.id}
                            <Launch sx={{ fontSize: '1rem', ml: 0.5 }} onClick={(event) => handleGotoFlight(event, loadedOrder)} />
                          </Link>
                        </Box>
                      )}
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              <Grid item xs={12} md={6}>
                <Grid container direction="column" spacing={3}>
                  {/* 受取人・配送物情報 */}
                  <Grid item>
                    <Card sx={{ borderRadius: '12px' }}>
                      <CardContent>
                        {isMaritimeOrderInfo(loadedOrder) ? (
                          <React.Fragment>
                            <Grid container alignItems="center" wrap="nowrap" sx={{ mb: 1 }}>
                              <Grid item sx={{ display: 'flex', alignItems: 'center', mr: 1.5 }}>
                                <PersonOutline sx={{ color: 'text.secondary' }} />
                              </Grid>
                              <Grid item>
                                <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                                  荷送人情報
                                </Typography>
                              </Grid>
                            </Grid>

                            <Grid container direction="column" sx={{ pl: 4.5 }}>
                              <Grid item>
                                <Typography color="text.primary" sx={{ mb: 0.5, fontWeight: 'bold' }}>補給本部</Typography>
                              </Grid>
                              {renderPartyInfoItems(loadedOrder.requester.supplyHeadquartersInfo, loadedOrder.requester.supplyHeadquartersInfo.unitName)}
                              <Divider sx={{ my: 2 }} />
                              <Grid item>
                                <Typography color="text.primary" sx={{ mb: 0.5, fontWeight: 'bold' }}>補給元部隊</Typography>
                              </Grid>
                              {renderPartyInfoItems(loadedOrder.requester.supplySourceUnitInfo, loadedOrder.requester.supplySourceUnitInfo.unitName)}
                            </Grid>
                          </React.Fragment>
                        ) : (
                          renderPartyInfo(
                            '荷送人情報',
                            requesterContact!,
                            isBusinessRequesterInfo(loadedOrder.requester) ? loadedOrder.requester.companyName : undefined
                          )
                        )}

                        <Divider sx={{ my: 2 }} />
                        {renderPartyInfo(
                          '荷受人情報',
                          destinationContact!,
                          isMaritimeOrderInfo(loadedOrder)
                            ? loadedOrder.destination.transportRequestUnit.unitName
                            : (isBusinessDestinationInfo(loadedOrder.destination) ? loadedOrder.destination.companyName : undefined)
                        )}
                        <Divider sx={{ my: 2 }} />

                        {/* 配送物 (複数表示に対応) */}
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, justifyContent: 'space-between' }}>
                          <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            <Inventory2Outlined sx={{ mr: 1.5, color: 'text.secondary' }} />
                            <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                              配送物
                            </Typography>
                          </Box>
                          {isMaritimeOrderInfo(loadedOrder) ? (
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<AddPhotoAlternateOutlined />}
                              onClick={() => setOrderImageDialogOpen(true)}
                            >
                              外観写真
                            </Button>
                          ) : null}
                        </Box>
                        <Box sx={{ pl: 4.5 }}>
                          {loadedOrder.goods.map((goodInfo, index) => (
                            <Paper key={index} variant="outlined" sx={{ p: 2, mb: 1.5, borderRadius: '12px' }}>
                              <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                                <Grid item>
                                  <Typography sx={{ fontWeight: 'medium', fontSize: '1.1rem' }}>{goodInfo.name != null ? goodInfo.name : "荷物"}</Typography>
                                </Grid>
                                <Grid item>
                                  {isMaritimeOrderInfo(loadedOrder) ? (
                                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75, alignItems: 'flex-end' }}>
                                      <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 2, width: '100%' }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                                          寸法
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', textAlign: 'right' }}>
                                          {getSizeLabel(goodInfo)}
                                        </Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 2, width: '100%' }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                                          体積
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', textAlign: 'right' }}>
                                          {getVolumeLabel(goodInfo)}
                                        </Typography>
                                      </Box>
                                      <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 2, width: '100%' }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ whiteSpace: 'nowrap' }}>
                                          重さ
                                        </Typography>
                                        <Typography variant="body2" sx={{ fontWeight: 'bold', textAlign: 'right' }}>
                                          {getWeightLabel(goodInfo)}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  ) : (
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                                      <Box sx={{ textAlign: 'center', p: 1, borderRadius: '8px', backgroundColor: 'action.hover' }}>
                                        <Typography variant="caption" display="block" color="text.secondary">
                                          ボックス
                                        </Typography>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
                                          {goodInfo.packageType}
                                        </Typography>
                                      </Box>
                                      <Box sx={{ textAlign: 'center', p: 1, borderRadius: '8px', backgroundColor: 'action.hover' }}>
                                        <Typography variant="caption" display="block" color="text.secondary">
                                          温度
                                        </Typography>
                                        <Typography variant="h6" sx={{ fontWeight: 'bold', lineHeight: 1.2 }}>
                                          {goodInfo.handlingInstructions?.[0] ?? "室温"}
                                        </Typography>
                                      </Box>
                                    </Box>
                                  )}
                                </Grid>
                              </Grid>
                            </Paper>
                          ))}
                        </Box>
                        <Divider sx={{ my: 2 }} />
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <ScaleOutlined sx={{ mr: 1.5, color: 'text.secondary' }} />
                          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                            重量
                          </Typography>
                        </Box>
                        <Box sx={{ pl: 4.5, maxWidth: 200 }}>
                          <TextField
                            label="総重量 (g)"
                            size="small"
                            type="number"
                            value={getTotalWeight()}
                            onChange={handleTotalWeightChange}
                            disabled={isMaritimeOrderInfo(loadedOrder)}
                            inputProps={{ min: 0, step: '1' }}
                            fullWidth
                          />
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                  {/* 
                    注文情報 (画像表示に対応)
                    空白部分に入れ込めないか検討する
                  */}
                  <Grid item>
                    <Card sx={{ borderRadius: '12px' }}>
                      <CardContent>
                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                          <InfoOutlined sx={{ mr: 1.5, color: 'text.secondary' }} />
                          <Typography variant="h6" component="div" sx={{ fontWeight: 'bold' }}>
                            注文情報
                          </Typography>
                        </Box>
                        {isImageOnLoad && typeof loadedOrder.receiptFileName === 'undefined' ?
                          <Alert severity="info">注文情報が指定されていません</Alert> :
                          null
                        }
                        {isImageOnLoad ?
                          <CardMedia
                            component="img"
                            sx={{
                              width: navigator.userAgent.match(/iPhone|Android.+Mobile/) ?
                                '100%' :
                                '50%',
                              borderRadius: '8px',
                              mb: 1.5
                            }}
                            image={orderReceiptImageBase64}
                          /> :
                          <CircularProgress />
                        }
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <FlightCreateDialog
              isFlightCreateDialogOpen={isNewFlightDialogOpen}
              setFlightCreateDialogOpen={setNewFlightDialogOpen}
              userInfo={userInfo}
              orderInfo={loadedOrder}
            />
            <OrderImageDialog
              isOrderImageDialogOpen={isOrderImageDialogOpen}
              setOrderImageDialogOpen={() => setOrderImageDialogOpen(false)}
              displayOrderInfo={loadedOrder}
              prefetchedPhaseImageState={maritimePhaseImageState}
              isPrefetchingMaritimeImages={isPrefetchingMaritimeImages}
              maritimeImageErrorMessage={maritimeImageErrorMessage}
              onPackageImageUpdated={() => setMaritimeImageRefreshNonce(prev => prev + 1)}
            />
            <OrderTieFlightDialog
              isOrderTieFlightDialogOpen={isOrderTieFlightDialogOpen}
              setOrderTieFlightDialogOpen={setOrderTieFlightDialogOpen}
              orderInfo={loadedOrder}
              setFlight={setFlight}
            />
          </React.Fragment>
        ) : null}

        <Backdrop className={classes.backdrop} open={orderState.kind === 'loading' || isDisplayLoadingMarkForUserInfo}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </main >
    </div >
  );
}